import React, { useEffect, useState } from 'react';
import { CoopRelationshipDTO } from '@bb/domain/dist/types';
import { getCoopRelationships } from 'api/SupraController';
import styled from 'styled-components';
import { TableProps } from 'components';
import { CoopListTable } from '../../components';

export const columns: TableProps['columns'] = ([
  {
    title: 'Organization',
    dataIndex: 'name',
    key: 'coopOrgName',
    sorter: (
      { name: name1 }: { name: string },
      { name: name2 }: { name: string },
    ) => name1.localeCompare(name2),
    render: (name: string, { label }) => <span>{`${name} (${label})`}</span>,
  },
  {
    // As of implementation, all co-ops are auto co-ops
    // TODO - update this when manual co-ops are implemented
    title: 'Co-op Type',
    dataIndex: 'type',
    key: 'coopOrgType',
    render: (type: string) => (
      <span>{type === 'manual' ? 'Manual' : 'Auto'}</span>
    ),
    filters: [
      { text: 'Auto', value: 'auto' },
      { text: 'Manual', value: 'manual' },
    ],
    onFilter(value, record) {
      return value === 'manual'
        ? record.type === 'manual'
        : record.type !== 'manual';
    },
  },
  {
    title: 'Key Status',
    dataIndex: 'disabled',
    key: 'coopOrgStatus',
    render(_, { disabled }) {
      return (
        <FlexSpan
          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
        >
          <StyledStatus disabled={disabled} />
          <span>{disabled ? 'Disabled' : 'Active'}</span>
        </FlexSpan>
      );
    },
    filters: [
      { text: 'Active', value: false },
      { text: 'Disabled', value: true },
    ],
    onFilter(value, record) {
      return record.disabled === value;
    },
  },
] as TableProps['columns'])!.filter(Boolean);

const CoopOrgTable: React.FC = () => {
  const [coops, setCoops] = useState<CoopRelationshipDTO[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCoopRelationships = async () => {
      const coopRelationships = await getCoopRelationships();
      setCoops(coopRelationships);
      setLoading(false);
    };

    fetchCoopRelationships();
  }, []);

  return <CoopListTable coops={coops} columns={columns} loading={loading} />;
};

// #region Styled components
const FlexSpan = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const StyledStatus = styled.span<{ disabled: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ disabled }) => (disabled ? 'red' : 'green')};
`;
// #endregion

export default CoopOrgTable;
